import { AtSign, Heart, MessageCircle, Repeat2, Send } from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot } from "./PreviewShell";

export function ThreadsPreview(props: PreviewProps) {
  return (
    <PreviewShell device={props.device} mobileFrame={false}>
      <div className="p-4">
        <div className="flex items-start gap-2.5">
          {props.pageAvatarUrl ? (
            <img
              src={props.pageAvatarUrl}
              alt={props.pageName}
              className="w-9 h-9 rounded-full object-cover bg-gray-100"
            />
          ) : (
            <div className="w-9 h-9 rounded-full flex items-center justify-center bg-gray-900">
              <AtSign size={14} className="text-white" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5">
              <span className="text-[13px] font-semibold text-gray-900 truncate">
                {props.pageName}
              </span>
              <span className="text-[11px] text-gray-400">1h</span>
            </div>
            {props.caption && (
              <p className="text-[13px] text-gray-900 whitespace-pre-wrap leading-relaxed mt-0.5">
                {props.caption}
              </p>
            )}
            {props.mediaUrl && (
              <div className="mt-2 rounded-2xl overflow-hidden border border-gray-100">
                <MediaSlot
                  mediaUrl={props.mediaUrl}
                  mediaType={props.mediaType}
                  aspect="aspect-[4/5]"
                />
              </div>
            )}
            <div className="flex items-center gap-4 mt-3 text-gray-700">
              <Heart size={17} />
              <MessageCircle size={17} />
              <Repeat2 size={17} />
              <Send size={17} />
            </div>
          </div>
        </div>
      </div>
    </PreviewShell>
  );
}
